import React from 'react';
import { Link } from 'react-router-dom';

export default () => {
    return (
        <div className="rbc-calendar__cta">
            <Link
                className="rbc-calendar__button-link rbc-calendar__button-link--add"
                to="/event"
            >
                Add Event
            </Link>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/ui/add-event-btn.js